import { render, staticRenderFns } from "./concierge-list.html?vue&type=template&id=027daa14&scoped=true&"
import script from "./concierge-list.js?vue&type=script&lang=js&"
export * from "./concierge-list.js?vue&type=script&lang=js&"
import style0 from "./concierge-list.scss?vue&type=style&index=0&id=027daa14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027daa14",
  null
  
)

export default component.exports